<template>
  <el-dialog
    title="Quote Results"
    width="97vw"
    top="2vh"
    :visible.sync="isVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <Results
      :quotes="quotes"
      :services="services"
    />

    <template #footer>
      <el-button
        @click.native="exportCsv"
      >
        Export
      </el-button>
      <el-button
        @click.native="isVisible = false"
      >
        Close
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import Results from './Results'

export default {
  components: {
    Results
  },
  props: {
    quotes: {
      type: Array,
      required: true
    },
    services: {
      type: Array,
      required: false,
      default: Array
    }
  },
  data () {
    return {
      isVisible: true
    }
  },
  methods: {
    exportCsv () {
      const csv = this.$papa.unparse(this.quotes)

      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `quote_results.csv`
      link.click()
    }
  }
}
</script>
